const META = 'recon-build-id';
const INTERVAL_MS = 5 * 60 * 1000;

function readBuildId(doc) {
	const el = doc.querySelector(`meta[name="${META}"]`);
	return el ? el.getAttribute('content') : null;
}

/**
 * Poll index.html for a new build id. Calls onUpdate when the served shell
 * differs from the one that booted this tab.
 */
export function startBuildUpdateCheck(onUpdate) {
	const current = readBuildId(document);
	if (!current) {
		return () => {};
	}

	let cancelled = false;

	const check = async () => {
		try {
			const res = await fetch(`${window.location.origin}/index.html?_=${Date.now()}`, {
				cache: 'no-store',
				credentials: 'same-origin',
			});
			if (!res.ok || cancelled) return;
			const html = await res.text();
			const next = readBuildId(new DOMParser().parseFromString(html, 'text/html'));
			if (next && next !== current) {
				onUpdate(next);
			}
		} catch {
			// ignore network blips
		}
	};

	const id = setInterval(check, INTERVAL_MS);
	// First check after a short delay so boot traffic settles.
	const first = setTimeout(check, 30_000);
	return () => {
		cancelled = true;
		clearInterval(id);
		clearTimeout(first);
	};
}
